<!--恒牙龋失补构成比统计-->
<template>
  <div>

    <el-card style="margin: 20px;">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item label="学校：">
          <ZxxSchool-select ref="schools" v-model="form.schoolId"></ZxxSchool-select>
        </el-form-item>
        <el-form-item label="年级：">
          <el-input v-model="form.grade"></el-input>
        </el-form-item>
        <el-form-item label="班级：">
          <el-input v-model="form.classRoomNo"></el-input>
        </el-form-item>
        <el-form-item label="性别：">
          <sex-select v-model="form.sex"></sex-select>
        </el-form-item>
        <el-form-item label="检测日期：" style="width: 400px;">
          <zxx-date-domain
              :checkEnd.sync="form.checkEnd"
              :checkStart.sync="form.checkStart"
          />
        </el-form-item>
        <el-col :lg="5" :xl="4">
          <el-form-item label="统计类型：" label-width="100px" style="width: 100%;">
            <statistical-type-select v-model="form.groupBy" :clearable="false" @updateValue="search"></statistical-type-select>
          </el-form-item>
        </el-col>

        <div style="display: flex; margin-left: auto">
          <div>
            <el-button v-show="$hasPermission('permanent.list')" size="small" type="primary" @click="search">查 询</el-button>
            <el-button v-show="$hasPermission('permanent.export')" size="small" type="primary" @click="exportExcel">导 出</el-button>
            <el-button v-show="$hasPermission('permanent.print')" size="small" type="primary" @click="printTable">打印当前页</el-button>
          </div>
        </div>

      </el-form>

    </el-card>
    <el-card style=" margin: 20px">
      <el-table
          id="exportTab"
          v-loading="loading"
          :data="formList2"
          border
          style="width: 100%"
      >
        <el-table-column
            :key="type"
            :label="type"
            prop="_id"
        >
          <template slot-scope="scope">
            <template v-if="form.groupBy === '$sex'">
              <div v-if="scope.row._id === 0">男</div>
              <div v-if="scope.row._id === 1">女</div>
              <div v-if="scope.row._id === '合计'">合计</div>
            </template>
            <template v-else>
              <div>{{ scope.row._id }}</div>
            </template>
          </template>
        </el-table-column>

        <el-table-column
            label="恒龋"
        >
          <el-table-column
              label="D+M+F牙数"
              prop="r047Sum"

          >
          </el-table-column>
          <el-table-column
              label="D牙数"
              prop="r011Sum"
          >
          </el-table-column>
          <el-table-column
              label="恒龋率(%)"
              prop="rate1"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.rate1 |percent }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="M牙数"
              prop="r013Sum"
          >
          </el-table-column>
          <el-table-column
              label="恒龋失率(%)"
              prop="rate2"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.rate2 |percent }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="F牙数"
              prop="r014Sum"
          >
          </el-table-column>
          <el-table-column
              label="恒龋补率(%)"
              prop="rate3"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.rate3 |percent }}</div>
            </template>
          </el-table-column>

        </el-table-column>


      </el-table>

      <div style="color: rgba(80, 155, 248, 1);font-size: 11px; margin-top: 20px">
        备注：恒龋率=D牙数/（D+M+F）牙数*100%；恒龋失=M牙数/（D+M+F）牙数*100%；恒龋补=F牙数/（D+M+F）牙数*100% 。
      </div>
    </el-card>
  </div>
</template>

<script>
import ZxxDateDomain from "@/components/ZxxDateDomain"
import ZxxSchoolSelect from "@/components/ZxxSchoolSelect"
import gradeSelect from "@/components/gradeSelect"
import classRoomNoSelect from "@/components/classRoomNoSelect"
import sexSelect from "@/components/sexSelect"
import yearSelect from "@/components/yearSelect"
import statisticalTypeSelect from "@/components/statisticalTypeSelect"
import * as scriptApi from "@/api/gen/scriptApi";

export default {
  name: "permanent",
  components: {
    ZxxSchoolSelect,
    statisticalTypeSelect,
    gradeSelect,
    classRoomNoSelect,
    sexSelect,
    yearSelect,
    ZxxDateDomain
  },

  data() {
    return {

      form: {
        id: "",
        schoolId: "",
        schoolType: "",
        idNo: "",
        grade: "",
        classRoomNo: "",
        name: "",
        birthDate: "",
        age: "",
        sex: "",
        studentId: "",
        contact: "",
        nationalityCode: "",
        cxType: "",
        checkDate: "",
        year: "",
        result: "",
        advice: "",
        groupBy: ""

      },
      formList: [],

      model: "",

      value: '',


      loading: false,
    }
  },
  computed: {
    type() {
      if (this.form.groupBy === '$age') {
        return '年龄(岁)'
      }
      if (this.form.groupBy === '$sex') {
        return '性别'
      }
      if (this.form.groupBy === '$grade') {
        return '年级'
      }
    },
    formList2() {
      var r047Sum = this._.sumBy(this.formList, 'r047Sum')
      var r011Sum = this._.sumBy(this.formList, 'r011Sum')
      var r013Sum = this._.sumBy(this.formList, 'r013Sum')
      var r014Sum = this._.sumBy(this.formList, 'r014Sum')
      this.formList.push({
        "_id": '合计',
        r047Sum: r047Sum,
        r011Sum: r011Sum,
        r013Sum: r013Sum,
        r014Sum: r014Sum,
        rate1: r047Sum ? r011Sum / r047Sum : 0,
        rate2: r047Sum ? r013Sum / r047Sum : 0,
        rate3: r047Sum ? r014Sum / r047Sum : 0
      })
      return this.formList
    }

  },
  mounted() {


  },
  methods: {

    async search() {
      if (!this.form.schoolId) {
        this.$message.warning('请选择学校')
        return
      }
      await this.scriptList()

    },


    async scriptList() {
      this.loading = true
      let clone = this._.cloneDeep(this.form)
      if (!clone.schoolId) {
        clone.schoolId = this.$refs.schools.getItems().map(item => item.id).join(',')
      }

      if (clone.sex) {
        if (clone.sex == '男') {
          clone.sex = 0;
        } else {
          clone.sex = 1;
        }
      }

      let tmp = await scriptApi.execute({name: '全部统计.groovy', params: clone})


      tmp.forEach(item => {
        item.rate1 = this.divide(item.r011Sum, item.r047Sum)
        item.rate2 = this.divide(item.r013Sum, item.r047Sum)
        item.rate3 = this.divide(item.r014Sum, item.r047Sum)

      })

      this.formList = this._.chain(tmp).sortBy(x => parseFloat(x._id)).value()
      this.$sortByGrade(this.formList)
      this.loading = false


    },

    exportExcel() {
      var sex = this.form.sex
      var grade = this.form.grade
      var classRoomNo = this.form.classRoomNo
      var query = []
      var queryStr = ""
      if (sex) {
        query.push(sex)
      }
      if (grade) {
        query.push(grade)
      }
      if (classRoomNo) {
        query.push(classRoomNo)
      }
      if (query.length > 0) {
        queryStr = query.join("-")
      }
      if (queryStr) {
        queryStr = queryStr + "-"
      }
      this.$exportToExcel(`${this.$store.getters.organizationName}-${this.form.year}-${queryStr}${this.$storage.getStorage('pageName')}-${this.$dateString(this.$now())}.xlsx`, '#exportTab', queryStr)
    },
    // exportExcel() {
    //   this.$exportToExcel(`${this.$store.getters.organizationName}-${this.form.year}-${this.$storage.getStorage('pageName')}-${this.$dateString(this.$now())}.xlsx`, '#exportTab')
    // },


    printTable() {

      this.$print('#exportTab')
    },
    divide(a, b) {
      if (a === 0 || b === 0) {
        return 0
      }
      return (a / b)
    }


  }
}

</script>

<style scoped>
.el-card .el-form {
  display: flex;
  flex-wrap: wrap;

}

/deep/ .el-form-item {
  width: 13%;
}

/deep/ .el-table td,
/deep/ .el-table th {
  text-align: center;
}

/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border: 1px solid #EBEEF5 !important;
}

/deep/ .el-table--border th, /deep/ .el-table__fixed-right-patch {
  border: 1px solid #EBEEF5 !important;
}
</style>
